import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getChallanOrders } from "../../utils/api";
import CustomModal from "../Modal";
import ChallanTable from "../ChallanTable";
import Loading from "../Loading";
import useStore from "../../utils/store";

const ChallanModal = ({ customerId, customerName, client, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const startDate = useStore((state) => state.startDate);
  const endDate = useStore((state) => state.endDate);

  const getChallansHandler = async () => {
    setLoading(true);
    try {
      const [success, resData] = await getChallanOrders(
        startDate,
        endDate,
        customerId
      );
      if (success && Array.isArray(resData)) {
        let filtered = resData;
        if (customerId) {
          filtered = resData
            .map((group) => ({
              ...group,
              orders: group.orders?.filter(
                (o) =>
                  !customerId ||
                  String(o?.customer?._id || o?.customer) === String(customerId)
              ),
            }))
            .filter((group) => group.orders && group.orders.length > 0);
          // If mapping filter reduced everything to 0 but resData has groups for this customer, use resData
          if (filtered.length === 0 && resData.length > 0) {
            filtered = resData;
          }
        }
        setData(filtered);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching challans");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getChallansHandler();
    }
  }, [open, customerId, startDate, endDate]);

  return (
    <>
      <div
        className="flex text-white w-fit font-semibold bg-primary px-3 py-2 border border-black cursor-pointer items-center gap-1 hover:brightness-110 active:scale-95 transition select-none"
        onClick={() => {
          setOpen(true);
        }}
      >
        <span>Challan</span>
      </div>

      {open && (
        <CustomModal
          width="w-full max-w-5xl"
          open={open}
          setOpen={setOpen}
          title={`Challan - ${customerName || "Customer"}`}
          button={
            <div className="flex justify-between items-center w-full pt-2">
              <span className="text-xs text-gray-500 font-medium">
                {data?.length || 0} Challan Group(s) found
              </span>
              <button
                type="button"
                onClick={getChallansHandler}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-xs font-bold py-1.5 px-3.5 rounded-lg border border-gray-300 shadow-sm transition active:scale-95 cursor-pointer"
              >
                🔄 Refresh
              </button>
            </div>
          }
        >
          <div className="flex flex-col gap-3 max-h-[70vh] overflow-y-auto p-1">
            {loading ? (
              <div className="py-12 flex flex-col items-center justify-center gap-2">
                <Loading />
                <span className="text-xs text-gray-500 font-semibold">Loading Challans...</span>
              </div>
            ) : (
              <ChallanTable
                data={data}
                refresh={() => {
                  getChallansHandler();
                  onUpdate?.();
                  window.dispatchEvent(new Event("plabel-data-updated"));
                  localStorage.setItem("plabel_last_sync", Date.now().toString());
                }}
              />
            )}
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default ChallanModal;
